import { Text } from '@chakra-ui/react';
import { formatPrice } from '../../utils/formatters';
import { useCurrency } from '../../contexts/CurrencyContext';

export const Price = ({ cents, size }) => {
  const { rate, symbol } = useCurrency();
  const usd = formatPrice(cents);

  if (!rate || !symbol || !cents) {
    return <>{usd}</>;
  }

  const converted = Math.round((cents / 100) * rate);

  return (
    <>
      {usd}
      <Text
        as="span"
        fontSize={size === 'sm' ? 'xs' : 'sm'}
        color="gray.400"
        fontWeight="normal"
        ml={1}
      >
        (~{symbol}{converted})
      </Text>
    </>
  );
};
